export const fieldIds = {
  googleAdwordsClickId: "00N5800000DhLyX",
  trackingVisitorId: "00N1i000000OKLj",
  trackingContainerId: "00N1i000000OKLt",
  trackingUtmCampaign: "utm_campaign",
  trackingUtmSource: "utm_source",
  trackingUtmMedium: "utm_medium",
  leadSource: "lead_source",
  studySMEDownloaded: "00N1i0000013lLg",
  publicationId: "00N580000084QWl", // "Acquisition Channel" in Salesforce
  product: "00N5800000CPQxr",
  productSubgroup: "00N5800000BWU5r",
  description: "description",
  productRegion: "00N5800000BWU6G",
  productContinent: "00N5800000BWXMH",
  // industrySegment: "00N1i000000OTOH", // use "industryVertical" instead
  industryVertical: "00N5q000000uf3q",
  industryOther: "00N1i0000013vaR",
  source: "00N5800000DKvSj",
  sourceOther: "00N5800000DKvSo",
  funding: "00N1i0000014vSx",
  liveStatus: "00N1i0000014vSy",
  operationAge: "00N1i0000014vSw",
  customers: "00N1i0000014vSz",
  plannedLaunchDate: "00N1i0000014vT0",
  employees: "00N1i0000014BqK",
  targetAudience: "00N5q000000uffa",
  legalEntityName: "00N580000084QWm",
  brandName: "company",
  firstName: "first_name",
  lastName: "last_name",
  position: "title",
  street: "street",
  state: "state",
  zipCode: "zip",
  city: "city",
  country: "country",
  email: "email",
  phone: "phone",
  linkedin: "00N58000009Iw05",
  website: "URL",
}
